module.exports = __webpack_public_path__ + "prod/1.42.2/img/cptx4.b1f36068.png";